<div class="search_form">
  <mat-form-field class="search_form_field" appearance="outline">
 <span class="search-icon-prefix" matPrefix>
          <mat-icon style="margin-right: 5px;">search</mat-icon>
        </span>
    <input class="searchbar_input" type="text"
           placeholder="Suche"
           (keyup)="applySearch($event)"
           matInput>
  </mat-form-field>

</div>
